import React from 'react';
import ControlsAdd from './ControlsAdd';
const ControlsAddXS = ({ color, ...props }) => (React.createElement(ControlsAdd, Object.assign({ color: color, size: 16 }, props)));
ControlsAddXS.displayName = 'ControlsAddXS'; // Fix for tsc
export default ControlsAddXS;
//# sourceMappingURL=ControlsAddXS.js.map